import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import user from "../../assets/icon/UserJob.png";
import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router";
import Footer from "../../common/Footer";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { getAllJob, getAllJobsMarketplace } from "./jobListApi";
import { useDispatch, useSelector } from "react-redux";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import SortIcon from "@mui/icons-material/FilterList";
import { routePath } from "../../constants/routePath";
import { setchangeRoll } from "../../app/store/reducer";
export default function Jobs() {
  const [allJobs, setAllJobs] = useState([]);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [visibleCount, setVisibleCount] = useState(12);
  const dispatch = useDispatch();

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));
  const token = sessionStorage.getItem("smbToken");

  const fetchAllJobsMarketplace = async () => {
    try {
      const payload = {
        billerId: billerId || 0,
        filter: "",
        search: "",
      };
      console.log("Job billerd ", billerId);

      // const res = await getAllJobsMarketplace(payload);
      if (token) {
        getAllJob(payload, (data) => {
          setAllJobs(data.data.data.list);
        });
      } else {
        getAllJobsMarketplace(payload, (data) => {
          setAllJobs(data.data.data.list);
        });
      }
    } catch (error) {
      console.error("Failed to fetch jobs", error);
    }
  };

  useEffect(() => {
    fetchAllJobsMarketplace();
  }, []);
  const navigate = useNavigate();

  const HandleValidation = () => {
    if (token) {
      navigate(`/myjobprofile`);
    } else {
      Swal.fire({
        text: "Please Login First",
        icon: "error",
        ...swalAlertPopProps,
      });
      navigate(`/login`);
    }
  };
  const handleShowMore = () => {
    setVisibleCount((prev) => Math.min(prev + 10, allJobs.length));
  };

  const handleShowLess = () => {
    setVisibleCount((prev) => Math.max(prev - 10, 10));
  };

  return (
    <>
      <Box
        sx={{
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
          p: { xs: 2, sm: 3, md: 5 },
          px: { xs: 2, sm: 6, md: 12 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: 18,
                sm: 22,
                md: 28,
              },
              fontWeight: 500,
            }}
          >
            Jobs Available For You
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Filter Icon */}
            <SortIcon
              sx={{
                fontSize: { xs: 28, sm: 32, md: 36 },
                cursor: "pointer",
                color: "#000", // change color as needed
                display: { md: "none", lg: "none", xs: "block" },
              }}
              onClick={() => {
                navigate(routePath.JOBSLIST);
              }}
            />

            <Box
              onClick={HandleValidation}
              component="img"
              src={user}
              alt="User"
              sx={{
                width: { xs: 32, sm: 36, md: 40 },
                height: { xs: 32, sm: 36, md: 40 },
                cursor: "pointer",
              }}
            />
          </Box>
        </Box>

        <Grid container spacing={{ xs: 2, sm: 3 }}>
          {/* {allJobs.length === 0 && (
            <Typography sx={{ m: 3 }}>
              No jobs available
            </Typography>
          )} */}

          {allJobs.slice(0, visibleCount).map((job) => (
            <Grid item xs={12} md={6} lg={4} sm={6} key={job.id}>
              <Box
                onClick={() => {
                  navigate(`/apply/${job.id}`);
                  sessionStorage.setItem("mode", "customer");
                  dispatch(setchangeRoll("customer"));
                }}
                sx={{
                  p: 2.5,
                  borderRadius: 2,
                  backgroundColor: "#EAEAFF",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  position: "relative",
                  cursor: "pointer",
                }}
              >
                {/* Left Content */}
                <Box>
                  <Typography
                    sx={{
                      fontSize: { xs: "16px", sm: "22px", md: "27px" },
                      fontWeight: 600,
                    }}
                  >
                    {job.designation || "-"}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "13px", sm: "16px", md: "18px" },
                      fontWeight: 500,
                      mt: 0.5,
                    }}
                  >
                    {job.enterpriseName}
                  </Typography>

                  <Box sx={{ mt: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 0.5,
                        gap: 2,
                      }}
                    >
                      <Box
                        component="img"
                        src={location}
                        alt="Location"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {job.preferredLocation}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        mb: 0.5,
                        gap: 2,
                      }}
                    >
                      <Box
                        component="img"
                        src={rupees}
                        alt="Salary"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography
                        sx={{
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          fontWeight: 500,
                        }}
                      >
                        {job.minSalary} – {job.maxSalary} / month
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        component="img"
                        src={vacancy}
                        alt="Vacancies"
                        sx={{ width: 20, height: 20 }}
                      />
                      <Typography sx={{ fontSize: 13, fontWeight: 500 }}>
                        {job.noOfVacancies} Vacancies
                      </Typography>
                    </Box>

                    {job.hasApplied && (
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: 12,
                          right: 16,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                        }}
                      >
                        <CheckCircleIcon
                          sx={{ fontSize: 16, color: "#2ECC71" }}
                        />
                        <Typography
                          sx={{
                            fontSize: 13,
                            fontWeight: 600,
                            color: "#2ECC71",
                          }}
                        >
                          Already Applied
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Right Icon */}
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    backgroundColor: "#E6E8FF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 600,
                  }}
                >
                  <Box
                    borderRadius={10}
                    component="img"
                    src={job.logoPath}
                    height={50}
                  />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>

        {allJobs.length > 10 && (
          <Box
            onClick={
              visibleCount >= allJobs.length ? handleShowLess : handleShowMore
            }
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 600,
              fontFamily: "Montserrat",
              fontSize: "18px",
              gap: "4px",
              cursor: "pointer",
              mt: 4,
            }}
          >
            {visibleCount >= allJobs.length ? (
              <>
                Show Less <ArrowUpwardIcon />
              </>
            ) : (
              <>
                Show More <ArrowDownwardIcon />
              </>
            )}
          </Box>
        )}
      </Box>
      <Box sx={{ pt: 10 }}>
        <Footer />
      </Box>
    </>
  );
}
